import { render } from "./DomainView.vue?vue&type=template&id=1f52f8d1&scoped=true"
import script from "./DomainView.vue?vue&type=script&lang=js"
export * from "./DomainView.vue?vue&type=script&lang=js"

import "./DomainView.vue?vue&type=style&index=0&id=1f52f8d1&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f52f8d1"]])

export default __exports__